import { module as BaseModule } from 'modujs';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.swiper = null;
  }

  initSlider() {

    this.swiper = new Swiper( this.$('slider')[0], {
      modules: [ Pagination ],
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    } );

  }

  init() {
    this.initSlider();
  }
}
